/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description mutate hook to patch code tenant data
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

const usePatchCodeTenantData = (): UseMutationResult<unknown, IAxiosError, CodeExplorer.IPatchCodeTenantData, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.CodeExplorerTenantDataApi.patchCodeTenantData({ patchCodeTenantDataModel: model });
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.codeTenantData] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default usePatchCodeTenantData;
